export default {"alert":"-ghg2","info":"Ik5x3","success":"afv9R","warning":"qrCG2","error":"ZP0gV"};